import { NODE_OFFSET_Y } from '../../../constants/layout';

const HEADER_HEIGHT = 112;
const FOOTER_HEIGHT = 46;
const EXTRA_GAP_AFTER_SIBLING_WITH_CHILDREN = 55;
const EXTRA_GAP_BEFORE_STACK = 22; // tweak to taste or make it a param
const EXTRA_GAP_FOR_HEADER_CARD = 60;
const GAP_BEFORE_FIRST_SON = 0; // used to add the type

const setPosition = (
  node,
  initialPos,
  scrollTop,
  viewPortHeight,
  mapNodeSize,
  arrayNodes,
  depth,
  parent,
  dynamic = true,
  displayMode
) => {
  const stack = depth > 0 && displayMode[depth - 1] === 'stack';
  const childLevelIsStack = displayMode[depth] === 'stack'; // children live at depth+1

  const hasStack = displayMode.includes('stack');

  let pos = initialPos + 45;

  node.ySize = mapNodeSize[node.key] || 10;
  if (node.children) {
    let length = node.children.length;
    for (let i = 0; i < length; i++) {
      if (i == 0) {
        pos += GAP_BEFORE_FIRST_SON; // we leave some space before first chidl
      }

      const currentNode = node.children[i];
      let current = {};

      if (i > 0) {
        const prevSibling = node.children[i - 1];
        if (
          prevSibling &&
          prevSibling.children &&
          prevSibling.children.length > 0
        ) {
          pos += EXTRA_GAP_AFTER_SIBLING_WITH_CHILDREN;
        }
      }
      // if first child of type card under stacked we leave place for headerCard
      else if (
        stack &&
        (displayMode[depth] === 'card' || displayMode[depth] === 'stackcard')
      ) {
        pos += EXTRA_GAP_FOR_HEADER_CARD;
      }

      pos = setPosition(
        currentNode,
        pos,
        scrollTop,
        viewPortHeight,
        mapNodeSize,
        arrayNodes,
        depth + 1,
        current,
        dynamic,
        displayMode
      );
      current.depth = depth + 1;
      current.data = currentNode;
      current.parent = parent;
      currentNode.wrapper = current;
      arrayNodes.push(current);
    }
  }

  let max = Math.max(initialPos + node.ySize + 15, pos);
  node.bndMin = initialPos;
  node.bndMax = max;
  if (stack) {
    // En mode stacked : le nœud est placé juste au-dessus du bloc englobant ses enfants
    if (node.children && node.children.length > 0) {
      node.y = initialPos;
    } else {
      // pas d'enfant, comportement normal
      node.y = initialPos + (max - initialPos) / 2 - node.ySize / 2;
    }
  } else {
    // Comportement normal
    node.y = initialPos + (max - initialPos) / 2 - node.ySize / 2;
  }

  if (!hasStack && !stack && max > pos) {
    // si on a utilise plus d'espace que nos enfants on peut les recentrer sur nous
    // we avoid this way of moving element afterwards if we have stack on the view
    let shiftChild = (max - pos) / 2;
    if (node.children) {
      let length = node.children.length;
      console.log(`children to reloc=${length}`);
      for (let i = 0; i < length; i++) {
        node.children[i].y += shiftChild;
        node.children[i].wrapper.y += shiftChild;
      }
    }
  } else if (!stack && node.children && node.children.length > 0 && dynamic) {
    // Si le nœud a des enfants, essayer de le centrer sur eux s'ils sont dans le view port
    const viewTop = scrollTop + HEADER_HEIGHT;
    const viewBottom = scrollTop + viewPortHeight - FOOTER_HEIGHT;

    let nodeInViewPort = node.children.filter((childnode) => {
      const childTop = childnode.y;
      const childBottom = childnode.y + childnode.ySize;
      return childBottom > viewTop && childTop < viewBottom; // any overlap counts
    });

    if (nodeInViewPort && nodeInViewPort.length > 0) {
      const childrenMin = Math.min(...nodeInViewPort.map((c) => c.y));
      const childrenMax = Math.max(...nodeInViewPort.map((c) => c.y + c.ySize));
      const idealCenter = (childrenMin + childrenMax) / 2;
      const halfWidth = node.ySize / 2;
      const targetY = idealCenter - halfWidth;
      if (
        targetY < node.bndMax - node.ySize / 2 &&
        targetY > node.bndMin + node.ySize / 2
      ) {
        node.y = targetY;
      }
    }
  }
  parent.y = node.y;
  parent.ySize = node.ySize;
  return max;
};

export const updateVerticalNodePositions = (
  rootNode,
  scrollTop,
  mapNodesSize,
  autoVertPos,
  displayMode
) => {
  const arrayNodes = [];
  if (rootNode) {
    // let fullNodes = treeRoot.descendants();
    // let rootElem = fullNodes.find((elem) => elem.data.key === 'root');
    let initialPos = NODE_OFFSET_Y;
    const viewPortHeight = document.documentElement.clientHeight;
    const depth = 0;
    setPosition(
      rootNode,
      initialPos,
      scrollTop,
      viewPortHeight,
      mapNodesSize,
      arrayNodes,
      depth,
      {},
      autoVertPos,
      displayMode
    );
  }

  // console.log('arrayModes');
  // console.log(arrayNodes);
  return arrayNodes;
};

// debugging function
function addDebugRect(id, top, height, color = 'red') {
  let el = document.getElementById(id);
  if (!el) {
    el = document.createElement('div');
    el.id = id;
    el.style.position = 'absolute';
    el.style.left = '0';
    el.style.width = '100%';
    el.style.pointerEvents = 'none';
    el.style.zIndex = '9999';
    document.body.appendChild(el);
  }

  el.style.top = `${top}px`;
  el.style.height = `${height}px`;
  el.style.backgroundColor = color;
  el.style.opacity = '0.2';
  el.style.border = '3px solid red';
  return el;
}
